// Импорт библиотек из node_modules
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Tab, Collapse, initTWE } from "tw-elements";

var ipad_width = 992,
    mobile_width = 768;

(function ($) {
    "use strict";

    $(document).ready(function () {

        /*******************************************/
        /* Header */
        /*******************************************/

        // $(window).scroll(function() {
        //     var scrollTop = $(this).scrollTop();
        //     const $header = $('#main-header');
        //
        //     if (scrollTop > 50) {
        //         $header.removeClass('bg-transparent').addClass('scrolled');
        //     } else {
        //         $header.removeClass('scrolled').addClass('bg-transparent');
        //     }
        // });

        /*******************************************/
        /* Slick sliders */
        /*******************************************/

        $(".slick-slider").slick({
            slidesToShow: 3,
            infinite:false,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000
            // dots: false, Boolean
            // arrows: false, Boolean
        });

        $('.js-latest-posts-slider').slick({
            rtl: true,
            arrows: true,
            dots: false,
            slidesToScroll: 1,
            slidesToShow: 4,
            infinite: true,
            nextArrow: '<i class="latest-posts-arrow latest-posts-left icon-circle-left cursor-pointer z-index-2 rounded-full bg-white"></i>',
            prevArrow: '<i class="latest-posts-arrow latest-posts-right icon-circle-right cursor-pointer z-index-2 rounded-full bg-white"></i>',
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        // centerMode: true,
                        // centerPadding: '60px',
                        arrows: false,
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        // centerMode: true,
                        // centerPadding: '60px',
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $('.js-main-slider-rtl').slick({
            speed: 9000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            arrows: false,
            dots: false,
        });

        $('.js-related-posts').slick({
            rtl: true,
            arrows: true,
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            nextArrow: '<i class="icon-nav-left icon-s y-align cursor-pointer z-index-2 w-auto pos-l-n4 text-color-1"></i>',
            prevArrow: '<i class="icon-nav-right icon-s y-align cursor-pointer z-index-2 w-auto pos-r-n4 text-color-1"></i>',

            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                    }
                }
            ]
        });

        $('.js-certificate-slider').slick({
            rtl: true,
            arrows: false,
            dots: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            infinite: true,
            nextArrow: '<i class="icon-nav-left icon-s y-align cursor-pointer z-index-2 w-auto pos-l-n4 text-color-1"></i>',
            prevArrow: '<i class="icon-nav-right icon-s y-align cursor-pointer z-index-2 w-auto pos-r-n4 text-color-1"></i>',

            responsive: [
                {
                    breakpoint: 9999,
                    settings: "unslick"
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                    }
                }
            ]
        });

        /*******************************************/
        /* AOS - MUST INIT AFTER SLICK! */
        /*******************************************/

        AOS.init({
            offset: 200,
            duration: 1000,
        });

        /*******************************************/
        /* tw-elements */
        /*******************************************/

        initTWE({ Tab, Collapse });

        console.log('TW Elements initialization');

        /*******************************************/
        /* BLOG */
        /*******************************************/

        $('.blog-cat').on('click', function () {
            $('.blog-cat').removeClass('current-cat');
            $(this).addClass('current-cat');
        })
        $('#post-category-select').on('change', function () {
            location = $(this).val();
        });

        $('#search-id').click(function () {
            $(this).closest('form').submit();
        });

        $('.js-blog-cats-slider').slick({
            rtl: true,
            arrows: true,
            dots: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            centerMode: true,
            variableWidth: true,
            nextArrow: '<i class="blog-cat-next icon-circle-left cursor-pointer"></i>',
            prevArrow: '<i class="blog-cat-prev icon-circle-right cursor-pointer"></i>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        variableWidth: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        variableWidth: true,
                    }
                }
            ]
        });

        /*******************************************/
        /* Video */
        /*******************************************/

        $('.video-cubic').click(function () {
            $(this).html($(this).data('iframe')).css('background', 'none');
        });

        /*******************************************/
        /* COUNTER */
        /*******************************************/
        if ($('#counter-box').length) {
            var a = 0;
            $(window).scroll(function () {
                var oTop = $("#counter-box").offset().top - window.innerHeight;
                if (a == 0 && $(window).scrollTop() > oTop) {
                    $(".counter").each(function () {
                        var $this = $(this),
                            countTo = $this.attr("data-number");
                        $({
                            countNum: $this.text()
                        }).animate(
                            {countNum: countTo},
                            {
                                duration: 4000,
                                easing: "swing",
                                step: function () {
                                    $this.text(
                                        Math.ceil(this.countNum).toLocaleString('en')
                                    );
                                },
                                complete: function () {
                                    $this.text(
                                        Math.ceil(this.countNum).toLocaleString('en')
                                    );
                                }
                            }
                        );
                    });
                    a = 1;
                }
            });
        }


    });


})(jQuery);